import { styled } from "@mui/material/styles";
import { theme } from "styles/themes";
import { mq } from "styles";

export const RequestCompleteContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const NoteHeader = styled("div")(() => ({
  color: theme.colors["blue-ribbon"],
  fontSize: "24px",
  fontWeight: 500,
  fontFamily: "Poppins",
  marginBottom: "15px",
  [mq.tabletUp]: {
    paddingRight: "70px",
  },
}));

export const NoteDetails = styled("div")(() => ({
  color: theme.colors["dark-blue"],
  fontSize: "16px",
  lineHeight: "19px",
  fontWeight: 500,
  marginBottom: "18px",
  [mq.tabletUp]: {
    paddingRight: "70px",
  },
}));

export const Paragraph = styled("p")(() => ({
  marginBottom: "16px",
}));

export const Bold = styled("span")(() => ({
  fontWeight: 700,
}));

export const VisionRequestCompleteContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "36px",
  alignItems: "center",
}));

export const VisionProposalCard = styled("div")(() => ({
  background: theme.colors.white,
  borderRadius: "12px",
  padding: "32px",
  width: "100%",
  maxWidth: "500px",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  boxShadow: "0px 2px 8px rgba(0, 33, 96, 0.08)",
}));

export const VisionProposalCardHeader = styled("div")(() => ({
  color: theme.colors["blue-ribbon"],
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: "24px",
  textAlign: "center",
}));

export const VisionProposalInProgressHeader = styled("div")(() => ({
  color: theme.colors["darkest-blue"],
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: "24px",
  textAlign: "center",
  marginBottom: "24px",
}));

export const VisionDescriptionContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  color: theme.colors["dark-blue"],
  fontWeight: 600,
  fontSize: "16px",
}));

export const VisionDescriptionRow = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
}));

export const VisionNextStepsCard = styled("div")(() => ({
  background: theme.colors["cotton-boll"],
  borderRadius: "8px",
  padding: "16px 20px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  marginTop: "-10px",
}));

export const VisionNextStepsTitle = styled("div")(() => ({
  fontFamily: "Poppins",
  color: theme.colors["blue-ribbon"],
  fontWeight: 600,
}));

export const VisionNextStepsText = styled("div")(() => ({
  color: theme.colors["dark-blue"],
  fontSize: "15px",
  fontWeight: 500,
  lineHeight: "22px",
}));

export const VisionButtonText = styled("div")(() => ({
  fontSize: "18px",
  fontWeight: 700,
  display: "flex",
  alignItems: "center",
  gap: "12px",
}));

export const HomeownerDetailsContainer = styled("div")(() => ({
  width: "100%",
  maxWidth: "500px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
}));

export const DetailsRow = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
}));

export const HomeownerDetailsLabel = styled("div")(() => ({
  fontSize: "13px",
  fontWeight: 600,
  color: theme.colors["nepal-blue"],
  textTransform: "uppercase",
}));

export const DetailsText = styled("div")(() => ({
  color: theme.colors["dark-blue"],
  fontWeight: 600,
}));

export const DetailsTextDark = styled("div")(() => ({
  color: theme.colors["darkest-blue"],
  fontWeight: 600,
}));

export const ProposalNotesText = styled("div")(() => ({
  color: theme.colors["dark-blue"],
  fontWeight: 600,
  fontStyle: "italic",
  marginTop: "-10px",
}));

export const Divider = styled("div")(() => ({
  width: "100%",
  height: 1,
  background: theme.colors["botticelli-blue"],
}));

export const ExpandableSectionHeader = styled("div")(() => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  color: theme.colors["blue-ribbon"],
  fontWeight: 600,
}));

export const ExpandableSection = styled("div")(() => ({
  width: "100%",
  maxWidth: "500px",
}));

export const RotatingIconContainer = styled("div")(({ isRotated = false }: { isRotated?: boolean }) => ({
  transition: "transform 0.2s ease",
  marginTop: isRotated ? "0px" : "3px",
  marginBottom: isRotated ? "3px" : "0px",
  transform: isRotated ? "rotate(180deg)" : "rotate(0deg)",
}));

export const TurnaroundTimeSection = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  marginTop: "24px",
}));

export const ServiceHoursCard = styled("div")(() => ({
  marginTop: "16px",
  background: theme.colors["botticelli-blue-35"],
  borderRadius: "6px",
  padding: "12px 16px",
}));

export const ServiceHoursLabel = styled("div")(() => ({
  fontSize: "12px",
  fontWeight: 600,
  color: theme.colors["nepal-blue"],
  textTransform: "uppercase",
  marginBottom: "8px",
}));

export const ServiceHoursText = styled("div")(() => ({
  fontSize: "13px",
  color: theme.colors["dark-blue"],
  fontWeight: 600,
  lineHeight: "22px",
}));
